import {computed, ref} from "vue";
import {useStore} from "vuex";
import {ElMessage} from "element-plus";

export default () => {
    const store = useStore();
    const mode = computed(() => {
        return store.getters.chatMode;
    });
    const group_id = computed(() => {
        return store.state.currentSession;
    });
    // 回答中
    const writing = ref(false);
    const answer = ref("");
    //是否有图片
    const img_url = ref('');

    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    async function getAnswer(message, writingCallback) {
        let apiRoute =
            {
                "GPT-3.5-Turbo-16k模型": "/chat/sendText",
                "GPT-4": "/chat/sendText_4",
                "GPT-3.5-联网版": "/chat/sendText_35_lianwang",
                /* 			"GPT-4-备用线路1": "/chat/sendText_4_poe", */
                "GPT-4-备用线路2": "/chat/sendText_4_pianyi",
                "GPT-4-备用线路3": "/chat/sendText_4_cab",
                "Claude-Instant-100k 大模型": "/chat/sendText_4_100k",

            }[mode.value] || "/chat/sendText";
        if (img_url.value !== "") {
            apiRoute = '/chat/sendText_40_shitu';
        }
        console.log(apiRoute);
        console.log(img_url.value);

        writing.value = true;
        const response = await fetch("/web.php/" + apiRoute, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                group_id: group_id.value,
                message,
                img_url:img_url.value,
            }),
        });
        if (!response.ok) {
            writing.value = false;
            ElMessage.error(response.statusText);
            return;
        }
        writingCallback();
        if (response.body) {
            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");
            let done = false;
            const curAiMsg = "";
            while (!done) {
                const {value, done: readerDone} = await reader.read();
                if (value) {
                    const char = decoder.decode(value);
                    if (char === "\n" && curAiMsg.endsWith("\n")) {
                        continue;
                    }
                    if (char) {
                        if (char.indexOf("[error]") !== -1) {
                            writing.value = false;
                            answer.value = "";
                            const error = char.replace("[error]", "");
                            if (error.indexOf("请登录") !== -1) {
                                ElMessage.error(error);
                                store.commit("SET_SHOW_LOGIN", true);
                            } else if (error.indexOf("请充值") !== -1) {
                                store.commit("SET_SHOW_VIP", true);
                            } else {
                                ElMessage.error(error);
                            }
                            break;
                        }
                        // char = char.replaceAll("\n", "<br>");
                        writing.value = true;
                        answer.value += char;
                    }
                }
                done = readerDone;
            }
        } else {
            const blob = await response.blob();
            const text = await new Response(blob).text();
            console.log(text);
            answer.value = text;
        }

        writing.value = false;
        img_url.value = '';
        return Promise.resolve();
    }

    return {
        writing,
        img_url,
        answer,
        getAnswer,
    };
};
